<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div class="head" fxLayout="row" fxLayoutAlign="center center">
  <app-side-nav fxFlex="65" [isProductHome]="false"></app-side-nav>
  <h2 class="profile title notranslate" fxFlex="25" i18n>Profile</h2>
</div>
<div class="content" fxLayout="row" fxLayoutAlign="space-around center">
  <div fxFlex="25">
    <app-user-profile-pic [profile]="profilePic"></app-user-profile-pic>
  </div>
  <div fxLayout="column" fxFlex="60">
    <div class="name">
      <h6 class="profile label notranslate" i18n>Display Name</h6>
      <div fxLayoout="row" fxLayoutAlign="space-between center">
        <h4 fxFlex="90" class="profile">{{ name }}</h4>
        <img
          (click)="editProfile()"
          alt="profile"
          fxFlex="10"
          alt="edit"
          class="edit-icon"
          src="../../../../assets/icons/edit.svg"
        />
      </div>
    </div>
    <div *ngIf="email" class="name">
      <h6 class="profile label notranslate" i18n>Email</h6>
      <h4 class="profile">{{ email }}</h4>
    </div>
    <div *ngIf="contact" class="name">
      <h6 class="profile label notranslate" i18n>Phone</h6>
      <h4 class="profile">{{ contact }}</h4>
    </div>
    <span (click)="changePassword()" class="change-pass notranslate" i18n
      >Change Password</span
    >
  </div>
</div>
<div fxLayout="column" fxLayoutAlign="column">
  <app-quantity-view
    title="My Favorites"
    [quantity]="dataObj.length"
  ></app-quantity-view>
  <app-similar-images class="fav-images" [images]="images"></app-similar-images>
</div>
<div fxLayout="column">
  <div fxLayout="column" class="my-review">
    <h3 class="notranslate" i18n>My Reviews</h3>
    <div class="test" *ngIf="reviewDetailsNew.length">
      <div
        class="test2"
        *ngIf="
          reviewDetailsNew[0].reviews && reviewDetailsNew[0].reviews.length
        "
      >
        <div
          class="review"
          *ngFor="let review of reviewDetailsNew[0].reviews[0].targetDetails"
          fxLayout="column"
        >
          <app-review
            type="user"
            class="review"
            [review]="review"
            [stars]="review.rating"
          ></app-review>
          <mat-divider class="dividerLine"></mat-divider>
        </div>
      </div>
    </div>
    <div class="test">
      <p></p>
    </div>
    <!-- <div class='moreReviews' (click)= getReviews(pageNumber+1) *ngIf="currentCount < reviewCount">More</div> -->
  </div>
</div>
